import styled from "@emotion/styled";
import theme from "../../../../UI/theme";

export const StyledInput = styled.input`
    box-sizing: border-box;
    padding: 0;
    position: absolute;
    left: 0;
    z-index: -1;
    opacity: 0;
    overflow: visible;
    margin: 0;
    &:focus + label::before {
        box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
    }
    &:checked + label::after {
        background-color: #fff;
        -webkit-transform: translateX(0.75rem);
        transform: translateX(0.75rem);
    }
    &:checked + label::before {
        color: #fff;
        background-color: #007bff;
        border-color: #007bff;
    }
`;

export const StyledLabel = styled.label<{ isRegular: boolean }>`
    width: 100px;
    position: relative;
    margin-bottom: 0;
    vertical-align: top;
    display: inline-block;
    cursor: pointer;
    padding-top: 1px;
    text-transform: capitalize;
    font-weight: ${theme.typography.fontWeight.thin};
    &::before {
        content: "";
        position: absolute;
        display: block;
        border: #adb5bd solid 1px;
        left: -2.25rem;
        width: 1.75rem;
        pointer-events: all;
        border-radius: 0.5rem;
        transition: background-color 0.15s ease-in-out,
            border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
        top: 0.25rem;
        top: ${(props) => (props.isRegular ? "0.25rem" : "0.75rem")};
        height: 1rem;
    }
    &::after {
        content: "";
        display: block;
        position: absolute;
        top: calc(
            ${(props) => (props.isRegular ? "0.25rem" : "0.75rem")} + 2px
        );
        left: calc(-2.25rem + 2px);
        width: calc(1rem - 4px);
        height: calc(1rem - 4px);
        border-radius: 0.5rem;
        background-color: #adb5bd;
        transition: transform 0.15s ease-in-out,
            background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
            box-shadow 0.15s ease-in-out;
    }
    & div {
        font-size: 14px;
    }
`;

export const DaySelectorWrapper = styled.div`
    display: flex;
    width: 10%;
    align-items: center;
    @media screen and (max-width: 1220px) {
        align-self: start;
    }
`;

export const DaySelectorInputWrapper = styled.div`
    padding-left: 2.75rem;
    position: relative;
    z-index: 1;
    display: block;
    min-height: 1.5rem;
    text-align: center;
`;

export const ConsultationTogglerContainer = styled.div<{
    disabled: boolean;
    additional: boolean;
}>`
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    width: 12%;
    color: ${(props) =>
        props.disabled
            ? theme.colors.lightGray
            : props.additional
            ? "inherit"
            : theme.colors.primary};
    font-weight: ${theme.typography.fontWeight.thin};
    cursor: ${(props) => (props.disabled ? "default" : "pointer")};
    @media screen and (max-width: 1220px) {
        align-self: start;
        padding-top: 0.25rem;
    }
`;

export const DaySelectorPlaceholder = styled.div`
    width: 10%;
`;

export const DayRowContainer = styled.div<{
    additional: boolean;
    isRegular: boolean;
}>`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: ${(props) => (props.additional ? "0.75rem" : "2rem")};
    @media screen and (max-width: 1220px) {
        margin-top: ${(props) => (props.additional ? "2.5rem" : "2rem")};
    }
`;

export const ContentContainer = styled.div`
    padding: 0.25rem 2rem 2rem 2rem;
    max-height: calc(95vh - 266px);
    overflow-x: hidden;
`;
